/**
 * Ensures a URL is correctly formatted as absolute or relative.
 * - If the string is empty, returns "/".
 * - If the string starts with "https":
 *   - If it contains "/?", remove the slash before the query.
 *   - Otherwise, return as is.
 * - If it starts with "/", return as is.
 * - Otherwise, prepend a "/" and return.
 */
const formatHrefToSupportLegacyLink = (url: string): string => {
  if (!url) return "/";
  if (/^https?:\/\//i.test(url)) {
    // Remove a slash before ? in the path, e.g. /foo/?bar -> /foo?bar
    return url.replace(/\/(\?)/, "$1");
  }
  if (url.startsWith("/")) return url;
  return `/${url}`;
};

export default formatHrefToSupportLegacyLink;
